const UNICODE_MAP = [
    ['ksh', 'क्ष'], ['gya', 'ज्ञ'], ['tra', 'त्र'],
    ['chha', 'छ'], ['shr', 'श्र'],
    ['bh', 'भ'], ['ch', 'च'], ['dh', 'ध'], ['gh', 'घ'], ['jh', 'झ'],
    ['kh', 'ख'], ['ng', 'ङ'], ['ny', 'ञ'], ['ph', 'फ'], ['sh', 'श'],
    ['th', 'थ'], ['Th', 'ठ'], ['Dh', 'ढ'], ['aa', 'ा'], ['ee', 'ी'],
    ['ii', 'ी'], ['oo', 'ू'], ['uu', 'ू'], ['ai', 'ै'], ['au', 'ौ'],
    ['a', 'अ'], ['b', 'ब'], ['c', 'क'], ['d', 'द'], ['e', 'े'],
    ['f', 'फ'], ['g', 'ग'], ['h', 'ह'], ['i', 'ि'], ['j', 'ज'],
    ['k', 'क'], ['l', 'ल'], ['m', 'म'], ['n', 'न'], ['o', 'ो'],
    ['p', 'प'], ['q', 'क'], ['r', 'र'], ['s', 'स'], ['t', 'त'],
    ['u', 'ु'], ['v', 'भ'], ['w', 'व'], ['x', 'क्स'], ['y', 'य'],
    ['z', 'ज'], [' ', ' '],
  ];
  
  export function transliterate(input) {
    if (!input) return '';
    let out = '';
    let i = 0;
    const s = input || '';
    while (i < s.length) {
      let matched = false;
      for (const [rom, dev] of UNICODE_MAP) {
        if (s.slice(i, i + rom.length).toLowerCase() === rom.toLowerCase() && rom.length > 0) {
          out += dev;
          i += rom.length;
          matched = true;
          break;
        }
      }
      if (!matched) { out += s[i]; i += 1; }
    }
    return out;
  }